import { render, staticRenderFns } from "./SingleResearch.vue?vue&type=template&id=d01b9056&scoped=true&"
import script from "./SingleResearch.vue?vue&type=script&lang=js&"
export * from "./SingleResearch.vue?vue&type=script&lang=js&"
import style0 from "./SingleResearch.vue?vue&type=style&index=0&id=d01b9056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01b9056",
  null
  
)

export default component.exports